import React, { useEffect } from 'react';
import { HeaderFeature } from '@app/src/common/header';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { clearPackageConsumeData, fetchPackageConsume } from '@app/src/views/Package/listPackage';
import { ListAvailableFeature } from '@app/src/views/MyAccount/listAvailable';
import { MiniFooter } from '@app/src/common/MiniFooter';

const isClient = isClientEnv();

export const MyAccount: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const packageConsume = useSelector(state => state.package.dataConsume);

  useEffect(() => {
    if (isClient) {
      window.addEventListener('scroll', handleHeaderFixed);
      window.addEventListener('resize', handleHeaderFixed);
      handleHeaderFixed();
      return () => {
        window.removeEventListener('load', handleHeaderFixed);
        window.removeEventListener('resize', handleHeaderFixed);
        window.addEventListener('scroll', handleHeaderFixed);
      };
    }
  });

  const handleHeaderFixed = () => {
    const header = (window as any).document.getElementById('header');
    const headerHeight = header && header.offsetHeight || 0;
    const headAccount = (window as any).document.getElementById('headMyAccount') || null;

    if (window.pageYOffset > 0) {
      headAccount && headAccount.classList.add('fixed');
      headAccount.style.top = `${headerHeight}px`;
    } else {
      headAccount && headAccount.classList.remove('fixed');
      headAccount.style.top = '0px';
    }
  };

  useEffect(() => {
    if (userStorage && !userStorage.jwt || !userStorage) {
      history.push('/inicia-tu-sesion');
    }
    return () => {
      dispatch(clearPackageConsumeData());
    }
  }, []);

  useEffect(() => {
    if (packageConsume && Object.keys(packageConsume).length === 0 && userStorage && userStorage.data && userStorage.data.id) {
      dispatch(fetchPackageConsume(userStorage.data.id));
    }
  }, [packageConsume]);

  return (
    <React.Fragment>
      <HeaderFeature />
      <ListAvailableFeature />
      <ModalErrorFeature />
      <MiniFooter />
    </React.Fragment>
  )
}
